import React from 'react';

import BREAKPOINTS from '@mlb/react-patterns/style/breakpoints.ts';

import { useModalStore } from 'bdvp-common/src/hooks/store';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';
import { useMedia } from 'bdvp-common/src/hooks';

import useSelectedFiltersStore from '../hooks/store/useSelectedFiltersStore';
import TagsComponent from '../components/Tags';
import { FILTER_BREAKPOINT } from '../utils/constants';

const { FILTER_MODAL_NAME } = modalConstants;

const Tags = () => {

    const { isModalOpen } = useModalStore();
    const isFilterModalOpen = isModalOpen(FILTER_MODAL_NAME);
    const isFilterInModal = useMedia(
        [`(min-width: ${BREAKPOINTS[FILTER_BREAKPOINT]})`],
        [false],
        true
    );
    const { selectedFilters, removeSelectedFilter } = useSelectedFiltersStore();

    return (
        <TagsComponent
            selectedFilters={selectedFilters}
            removeFilter={removeSelectedFilter}
            shouldNotReRender={isFilterModalOpen && isFilterInModal}
        />
    );

};

export default Tags;
